import React from 'react';
// import { useNavigate } from "react-router-dom";

const SessionExpired = ({ setSessionExpired }) => {
    // const navigate = useNavigate()
    const containerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'linear-gradient(to bottom right, #0014ff, #00ffec)'
    };

    const cardStyle = {
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        padding: '40px',
        textAlign: 'center',
        maxWidth: '400px',
        margin: '2rem'
    };

    const iconContainerStyle = {
        backgroundColor: '#BFDBFE',
        borderRadius: '9999px',
        padding: '16px',
        display: 'inline-block',
        marginBottom: '24px'
    };

    const headingStyle = {
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '16px'
    };

    const textStyle = {
        color: '#6B7280',
        marginBottom: '24px'
    };

    const buttonStyle = {
        backgroundColor: '#2563EB',
        color: 'white',
        padding: '10px 24px',
        borderRadius: '9999px',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.3s'
    };

    const handleButtonHover = (e) => {
        e.target.style.backgroundColor = '#1D4ED8';
    };

    const handleButtonLeave = (e) => {
        e.target.style.backgroundColor = '#2563EB';
    };

    return (
        <div style={containerStyle}>
            <div style={cardStyle}>
                <div style={iconContainerStyle}>
                    <img src='/notFound.png' height="80" width="80" />
                </div>
                <h1 style={headingStyle}>Your session has expired</h1>
                <p style={textStyle}>Please refresh the page. Don't worry, you can login and continue on a new session. Happy Gaming.</p>
                <button
                    style={buttonStyle}
                    onMouseOver={handleButtonHover}
                    onMouseLeave={handleButtonLeave}
                    onClick={() => {
                        setSessionExpired(false)
                        // navigate(-1)
                        window.history.back()
                    }}
                >
                    Refresh
                </button>
            </div>
        </div>
    );
};

export default SessionExpired;
